// CLM course gating — ONE allowlist read by the element palette, the
// clipboard guard and the export serializers, so "what the editor lets you add"
// and "what the static exporter can write" never drift (spec §3.3 item 1, D5).
export const CLM_ALLOWED_PLUGINS = [
  "HotspotImages", // image
  "BasicText", // text
  "OneClick", // click zone (all navigation)
  "HtmlContent", // Animasyonlu HTML artifact
  "ShapeOverlay", // basic shapes
  "Shapes", // basic shapes, image-backed (registry-only, no palette card)
];

// Course-level mode allowlist. `globalConfig.mode` (written by course-gen /
// the mode dropdown in GlobalConfig) is the source of truth going forward;
// `clm.isClm` / `interactiveInfographic.isInteractiveInfographic` are the
// legacy signals it supersedes, and also the escape hatch OUT of CLM lock.
export const COURSE_MODES = [
  "clm",
  "infographic",
  "html_artifact",
  "presentation",
  "atomic_presentation",
  "mixed",
];

export function getCourseMode(globalConfig) {
  if (globalConfig?.mode && COURSE_MODES.indexOf(globalConfig.mode) !== -1) {
    return globalConfig.mode;
  }
  if (globalConfig?.clm?.isClm === true) return "clm";
  if (globalConfig?.interactiveInfographic?.isInteractiveInfographic === true) return "infographic";
  return "mixed";
}

export function isClmCourse(globalConfig) {
  return getCourseMode(globalConfig) === "clm";
}

export function isClmAllowedPlugin(pluginId) {
  return CLM_ALLOWED_PLUGINS.indexOf(pluginId) !== -1;
}

// Scene-paste payload shape: { toolbars, containedViews: { [cvId]: { toolbars } } }
// (clipboard.utils.js buildScenePayload). First offender wins.
export function findDisallowedClmPluginInScene(scene) {
  if (!scene) return null;
  const groups = [scene.toolbars || {}].concat(
    Object.keys(scene.containedViews || {}).map((cvId) => scene.containedViews[cvId].toolbars || {})
  );
  for (let g = 0; g < groups.length; g++) {
    const toolbars = groups[g];
    const ids = Object.keys(toolbars);
    for (let i = 0; i < ids.length; i++) {
      const pluginId = toolbars[ids[i]] && toolbars[ids[i]].pluginId;
      if (pluginId && !isClmAllowedPlugin(pluginId)) return pluginId;
    }
  }
  return null;
}
